import { isBagNumber } from '../../../../utils/BarCodeUtil';

/** 拆分文本框中混合输入的号码（换行 / 空格 / 逗号 / 分号，含全角），重复号码只保留一个 */
export const splitNumbers = (text: string | null | undefined): string[] =>
    Array.from(new Set(String(text || '')
        .split(/[\s,;，；]+/)
        .map((s) => s.trim())
        .filter(Boolean)));

/** 号码是否为包牌：标准包牌号（BAG + 13 位数字），或原型中的 BAG / B 数字开头简写 */
export const isBagLikeNumber = (no: string): boolean => isBagNumber(no) || /^(BAG|B\d)/i.test(no);

/**
 * 复制文本到剪贴板：只用 Clipboard API，不可用或写入失败时 reject，由调用方提示「复制失败」
 * （同 components/WmsDownloadModal 的复制处理）。
 */
export const copyToClipboard = async (text: string): Promise<void> => {
    if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard API unavailable');
    await navigator.clipboard.writeText(text);
};
